import _sfc_main from "./Select.vue2.js";
/* empty css            */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Select = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-077abac4"]]);
export {
  Select as default
};
//# sourceMappingURL=Select.vue.js.map
